module.exports = __webpack_public_path__ + "static/img/gs.e62fcd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gs.jpg
// module id = 5xxD
// module chunks = 1